module.exports = __webpack_public_path__ + "img/Mail.ed7e2db9.svg";